const libraryNavigation = (direction) => {

  const libraryBooks = document.querySelector(`[data-library-books]`)
  const libraryScrollLeft = parseInt(libraryBooks.scrollLeft)

  libraryBooks.scrollBy({
    top: 0,
    left: (direction === `prev`) ? -200 : 200, 
    behavior: `smooth` 
  })

}

const init = () => {

  const libraryBooks = document.querySelector(`[data-library-books]`)
  const libraryNavs = document.querySelectorAll(`[data-library-nav]`)

  if (libraryBooks && libraryBooks.scrollLeft <= 0) {
    document.querySelector(`[data-library-nav="prev"]`).classList.add(`is-hidden`)
  }

  for (const item of libraryNavs) {

    item.addEventListener(`click`, e => {
      e.preventDefault()
      libraryNavigation(item.dataset.libraryNav)
    })

  }

  if (libraryBooks) {

    setInterval(() => {
      if (libraryBooks.scrollLeft <= 0) {
        document.querySelector(`[data-library-nav="prev"]`).classList.add(`is-hidden`)
      } else {
        document.querySelector(`[data-library-nav="prev"]`).classList.remove(`is-hidden`)
      }

      if (libraryBooks.scrollWidth <= (libraryBooks.scrollLeft + libraryBooks.offsetWidth)) {
        document.querySelector(`[data-library-nav="next"]`).classList.add(`is-hidden`)
      } else {
        document.querySelector(`[data-library-nav="next"]`).classList.remove(`is-hidden`)
      }
    }, 350)
  
  }

}

export default {
  init
}
